<template>
    <Transition name="chatbot-intro-bubble">
        <div
            v-if="visible"
            class="chatbot-intro-bubble absolute bottom-full right-0 mb-3 w-[15rem] rounded-xl border px-4 py-3 pr-7 text-left shadow-lg border-black/10 bg-white text-[hsl(245_66%_23%)] dark:border-white/15 dark:bg-[hsl(207_12%_30%)] dark:text-white"
            role="status">
            <p class="text-[1rem] leading-snug">{{ message }}</p>
            <button
                type="button"
                class="absolute right-1.5 top-1.5 flex size-5 items-center justify-center rounded opacity-60 transition-opacity hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-current"
                @click="emit('close')">
                <svg viewBox="0 0 12 12" fill="none" class="size-3" aria-hidden="true">
                    <path
                        d="M1.5 1.5 10.5 10.5M10.5 1.5 1.5 10.5"
                        stroke="currentColor"
                        stroke-width="1.75"
                        stroke-linecap="round" />
                </svg>
                <span class="sr-only">Close message</span>
            </button>
            <span
                class="absolute -bottom-[0.375rem] right-5 size-3 rotate-45 border-b border-r border-black/10 bg-white dark:border-white/15 dark:bg-[hsl(207_12%_30%)]" />
        </div>
    </Transition>
</template>

<script setup lang="ts">
interface Props {
    visible?: boolean
    message: string
}

withDefaults(defineProps<Props>(), {
    visible: false,
})

const emit = defineEmits<{ close: [] }>()
</script>

<style scoped>
/* Fade only. Any transform here shifts the 16px text by sub-pixel amounts and makes it drift. */
.chatbot-intro-bubble-enter-active,
.chatbot-intro-bubble-leave-active {
    will-change: opacity;
}

.chatbot-intro-bubble-enter-active {
    transition: opacity 0.3s ease-out;
}

.chatbot-intro-bubble-leave-active {
    transition: opacity 0.2s ease-in;
}

.chatbot-intro-bubble-enter-from,
.chatbot-intro-bubble-leave-to {
    opacity: 0;
}
</style>
